/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1TutoraiDocumentsDocumentidEmbedding202,
  DeleteApiV1TutoraiDocumentsDocumentidEmbedding401,
  DeleteApiV1TutoraiDocumentsDocumentidEmbedding404,
  DeleteApiV1TutoraiDocumentsDocumentidEmbedding500,
  DeleteApiV1TutoraiDocumentsDocumentidEmbeddingMutationResponse,
  DeleteApiV1TutoraiDocumentsDocumentidEmbeddingPathParams,
} from "../../types/tutorAIDocumentosController/DeleteApiV1TutoraiDocumentsDocumentidEmbedding.ts";

export const deleteApiV1TutoraiDocumentsDocumentidEmbeddingPathParamsSchema =
  z.object({
    documentId: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1TutoraiDocumentsDocumentidEmbeddingPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1TutoraiDocumentsDocumentidEmbedding202Schema =
  z.any() as unknown as ToZod<DeleteApiV1TutoraiDocumentsDocumentidEmbedding202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1TutoraiDocumentsDocumentidEmbedding401Schema =
  z.any() as unknown as ToZod<DeleteApiV1TutoraiDocumentsDocumentidEmbedding401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1TutoraiDocumentsDocumentidEmbedding404Schema =
  z.any() as unknown as ToZod<DeleteApiV1TutoraiDocumentsDocumentidEmbedding404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1TutoraiDocumentsDocumentidEmbedding500Schema =
  z.any() as unknown as ToZod<DeleteApiV1TutoraiDocumentsDocumentidEmbedding500>;

export const deleteApiV1TutoraiDocumentsDocumentidEmbeddingMutationResponseSchema =
  z.lazy(
    () => deleteApiV1TutoraiDocumentsDocumentidEmbedding202Schema,
  ) as unknown as ToZod<DeleteApiV1TutoraiDocumentsDocumentidEmbeddingMutationResponse>;
